






































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ChallengeItemStats from './ChallengeItemStats.vue';
import { TimelineLite } from 'gsap';
import moment from 'moment-timezone';
import { ChallengeModel } from '@/models/challenge.model';
import { userModule } from '@/utils/store-acessor';

@Component({
  components: {
    ChallengeItemStats
  }
})
export default class ChallengeItem extends Vue {
  @userModule.Getter('timezone') timezone!: string;

  @Prop({ required: true })
  challenge!: ChallengeModel;

  @Prop({ required: false })
  hasSeveralChallenges?: boolean;

  @Prop({ required: false, default: 'black' })
  color!: string;

  get timeLeft() {
    if (this.challenge.deadline) {
      return this.$t('challenge.ending_in', [
        moment(this.challenge.deadline)
          .tz(this.timezone)
          .fromNow()
      ]);
    }

    return this.$t('challenge.closed');
  }

  get titleStyle() {
    return [
      'mb-4',
      'font-weight-black',
      this.$vuetify.breakpoint.xsOnly ? 'headline' : 'display-2'
    ];
  }

  get livesChanged() {
    return this.challenge.lives_changed;
  }

  openChallenge() {
    this.$router.push(`/challenges/${this.challenge.slug}`);
  }

  animate(direction: string) {
    const { challengeContainer, solveButton } = this.$refs;
    const tl = new TimelineLite({ delay: 0.4 });
    tl.fromTo(challengeContainer, 0.5, { opacity: 0.4 }, { opacity: 1 })
      .fromTo(
        solveButton,
        0.2,
        { opacity: 0.6, scale: 0.9 },
        { opacity: 1, scale: 1.1 }
      )
      .to(solveButton, 0.3, { scale: 1 });
  }
}
